import { Template } from "../models/Template";
import { isAutomationTemplate } from "./is-automation-template";
import { isStandardTemplate } from "./is-standard-template";

export function isSystemTemplate(template: Template) {
    if (!isStandardTemplate(template) && !isAutomationTemplate(template)) {
        return true;
    }

    return false;
}